import { render, staticRenderFns } from "./SuppliersList.vue?vue&type=template&id=e59ee8b0&"
import script from "./SuppliersList.vue?vue&type=script&lang=ts&"
export * from "./SuppliersList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports